module.exports = __webpack_public_path__ + "static/media/postcard1thumb.566b437d.jpg";